// extracted by mini-css-extract-plugin
export default {"root":"PageHeader_root__yjCzG","actions":"PageHeader_actions__Vzy3k","moreOptionsIcon":"PageHeader_moreOptionsIcon__Z9p1K"};